// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"100":"f03194d2","245":"74e6e73f","537":"dad13d9a"}[chunkId] + ".chunk.css";
};